import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { hooks } from "../hooks";

import { text } from "../text";
import { items } from "../items";
import { svg } from "../assets/svg";
import { theme } from "../constants";
import { components } from "../components";
// import logo from "../../src/assets/nestfin/NexfinPng.png"
import logo from "../../src/assets/nestfin/Nestfin_logo.png";

type DrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { pathname } = useLocation();
  const [leftPosition, setLeftPosition] = React.useState(0);

  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  // console.log(viewport, '...............');

  useEffect(() => {
    if (viewport.width > 650) {
      setLeftPosition((viewport.width - 650) / 2);
    } else {
      setLeftPosition(0);
    }
  }, [viewport.width]);

  // console.log(leftPosition, '....................');

  const navigate = hooks.useNavigate();

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const leadId = localStorage.getItem("lead_profile_id") ?? "";

    setIsLogin(!!accessToken && !!leadId); // sets to true if both exist
  }, []);

  // Start Component Here

  const renderImageBackground = (): JSX.Element => {
    return <components.Background version={1} />;
  };

  const renderHeader = (): JSX.Element => {
    return <components.Header title="My Profile" />;
  };

  const renderBottomTabBar = (): JSX.Element => {
    return <components.BottomTabBar />;
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className="container" style={{ paddingTop: "50px" }}>
        <div
          style={{
            width: "60%",
            margin: "0 auto",
            marginBottom: 20,
            marginTop: 10,
            position: "relative",
            cursor: "pointer",
            userSelect: "none",
          }}
          //   onClick={() => navigate("/profile/edit")}
          onClick={() => {
            window.location.href = "https://nestfin.app";
          }}
        >
          <img
            src={logo}
            alt="Profile"
            style={{ width: "100%", height: "auto" }}
          />
        </div>
        {/* 🏠 Back to Home always visible */}
        <items.ProfileItem
          navIcon={false}
          title="Back to Website"
          icon={<svg.BackToHome />}
          containerStyle={{ marginBottom: 6 }}
          onClick={() => {
            window.location.href = "https://nestfin.app"; // main landing page
          }}
        />

        <items.ProfileItem
          navIcon={true}
          title="Home"
          icon={<svg.HomeTabSvg2 />}
          containerStyle={{ marginBottom: 6 }}
          onClick={() => {
            window.location.href = "/home"; // main landing page
          }}
        />

        {/* 🔝 LOGIN AT THE TOP */}
        {!isLogin && (
          <items.ProfileItem
            navIcon={false}
            title="Login"
            icon={<svg.LogOutSvg />}
            containerStyle={{ marginBottom: 6 }}
            onClick={() => {
              // // ✅ Save values to persist
              // const savedLatLng = localStorage.getItem('selectedLatLng');
              // const savedLocality = localStorage.getItem('selectedLocality');
              // const locationPopupShown = localStorage.getItem('locationPopupShown');

              // // ✅ Clear storage
              // localStorage.clear();
              // localStorage.clear();

              // // ✅ Restore persisted values
              // if (savedLatLng) {
              //   localStorage.setItem('selectedLatLng', savedLatLng);
              // }
              // if (savedLocality) {
              //   localStorage.setItem('selectedLocality', savedLocality);
              // }
              // if (locationPopupShown) {
              //   localStorage.setItem('locationPopupShown', locationPopupShown);
              // }

              navigate("/onbording3");
            }}
          />
        )}

        {/* 🧭 Rest of menu items */}
        {/* {isLogin && (
              <items.ProfileItem
                title="Dashboard"
                icon={<svg.HomeTabSvg />}
                containerStyle={{ marginBottom: 6 }}
                onClick={() => navigate("/dashboard")}
              />
            )} */}

        {isLogin && (
          <>
            <items.ProfileItem
              title="My Bookings"
              icon={<svg.BookingSvg />}
              containerStyle={{ marginBottom: 6 }}
              onClick={() => navigate("/my-booking")}
            />
            {/* <items.ProfileItem
                            title='Shortlisted Properties'
                            icon={<svg.HeartSvg />}
                            containerStyle={{ marginBottom: 6 }}
                            onClick={() => navigate('/shortlisted')}
                        /> */}
          </>
        )}

        <items.ProfileItem
          title="Help Center"
          icon={<svg.HelpCirceSvg />}
          containerStyle={{ marginBottom: 6 }}
          onClick={() => navigate("/help-center")}
        />

        {/* <items.ProfileItem
                    title='View Help Center'
                    icon={<svg.HelpCirceSvg />}
                    containerStyle={{ marginBottom: 6 }}
                    onClick={() => navigate('/profile/help-and-support')}
                /> */}

        {/* <items.ProfileItem
                    title='Privacy Policy'
                    icon={<svg.FileTextSvg />}
                    containerStyle={{ marginBottom: 6 }}
                    onClick={() => navigate('/profile/privacy-policy')}
                /> */}

        {/* <items.ProfileItem
                    title='Terms & Conditions'
                    icon={<svg.FileTextSvg />}
                    containerStyle={{ marginBottom: 6 }}
                    onClick={() => navigate('/terms-conditions')}
                /> */}

        <items.ProfileItem
          title="Our Services"
          icon={<svg.FileTextSvg />}
          containerStyle={{ marginBottom: 6 }}
          onClick={() => navigate("/our-services")}
        />

        <items.ProfileItem
          title="Contact Us"
          icon={<svg.FileTextSvg />}
          containerStyle={{ marginBottom: 6 }}
          onClick={() => navigate("/contact-us")}
        />

        {/* 🔚 LOGOUT AT THE BOTTOM */}
        {/* {isLogin && (
              <items.ProfileItem
                navIcon={false}
                title="Sign out"
                icon={<svg.LogOutSvg />}
                containerStyle={{ marginBottom: 6 }}
                onClick={() => {
                  localStorage.clear();
                  localStorage.clear();
                  // navigate('/home');
                  onClose();
                  window.location.href = "/home"; // 🔄 Forces a full reload
                }}
              />
              
            )} */}

        {/* 🔚 LOGOUT AT THE BOTTOM */}
        {isLogin && (
          <items.ProfileItem
            navIcon={false}
            title="Sign out"
            icon={<svg.LogOutSvg />}
            containerStyle={{ marginBottom: 6 }}
            onClick={() => {
              // 🧹 Only remove specific keys
              const keysToRemove = [
                "accessToken",
                "lead_profile_id",
                "property_name",
                "property_id",
                "rzp_device_id",
                "roomType",
                "rzp_checkout_anon_id",
              ];

              keysToRemove.forEach((key) => localStorage.removeItem(key));

              onClose();
              window.location.href = "/home";
            }}
          />
        )}
      </main>
    );
  };

  return (
    <>
      {isOpen && (
        <div
          onClick={onClose}
          style={{
            position: "fixed",
            top: 0,
            left: leftPosition,
            // width: `100vw`, // Remaining screen
            width:
              viewport.width < 650
                ? "100vw"
                : `calc(100vw - ${leftPosition}px)`,
            // Remaining screen
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            // backgroundColor: "red",
            zIndex: "99997",
          }}
        />
      )}
      <div
        className="sidebar-drawer"
        style={{
          position: "fixed",
          top: 0,
          left: isOpen ? leftPosition : "-300px",
          width: 300,
          height: "100vh",
          backgroundColor: "#fff",
          boxShadow: "2px 0 10px rgba(0,0,0,0.2)",
          transition: "left 0.3s ease-in-out",
          zIndex: 99999,
          overflowY: "auto",
        }}
      >
        {/* {renderHeader()} */}
        {renderContent()}
      </div>
    </>
  );
};

// 05-07-2025
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { hooks } from '../hooks';

// import { text } from '../text';
// import { items } from '../items';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import logo from "../../src/assets/nestfin/NexfinPng.png"

// type DrawerProps = {
//     isOpen: boolean;
//     onClose: () => void;
// };

// export const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
//     const location = useLocation();
//     const { pathname } = useLocation();
//     const [leftPosition, setLeftPosition] = React.useState(0);

//     const [viewport, setViewport] = useState({
//         width: window.innerWidth,
//         height: window.innerHeight,
//     });

//     const [isLogin, setIsLogin] = useState(false)

//     useEffect(() => {
//         const handleResize = () => {
//             setViewport({
//                 width: window.innerWidth,
//                 height: window.innerHeight,
//             });
//         };
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     useEffect(() => {
//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     // console.log(viewport, '...............');

//     useEffect(() => {
//         if (viewport.width > 650) {
//             setLeftPosition((viewport.width - 650) / 2);
//         } else {
//             setLeftPosition(0);
//         }
//     }, [viewport.width]);

//     // console.log(leftPosition, '....................');

//     const navigate = hooks.useNavigate();

//     useEffect(() => {
//         const accessToken = localStorage.getItem('accessToken');
//         const leadId = localStorage.getItem('lead_profile_id');

//         setIsLogin(!!accessToken && !!leadId); // sets to true if both exist
//     }, []);

//     // Start Component Here

//     const renderImageBackground = (): JSX.Element => {
//         return <components.Background version={1} />;
//     };

//     const renderHeader = (): JSX.Element => {
//         return <components.Header title='My Profile' />;
//     };

//     const renderBottomTabBar = (): JSX.Element => {
//         return <components.BottomTabBar />;
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main className='container' style={{ paddingTop: "50px" }}>
//                 <div
//                     style={{
//                         width: '50%',
//                         margin: '0 auto',
//                         marginBottom: 20,
//                         marginTop: 10,
//                         position: 'relative',
//                         cursor: 'pointer',
//                         userSelect: 'none',
//                     }}
//                     onClick={() => navigate('/profile/edit')}
//                 >
//                     <img
//                         // src='https://george-fx.github.io/nuton_api/assets/users/01.jpg'
//                         src={logo}
//                         alt='Profile'
//                         style={{ width: '100%', height: 'auto', }}
//                     />
//                     {/* <img
//                         src={require('../assets/other/02.png')}
//                         alt='camera'
//                         style={{
//                             position: 'relative',
//                             right: 0,
//                             bottom: 0,
//                             width: '30%',
//                             height: 'auto',
//                         }}
//                     /> */}
//                 </div>
//                 {/* <text.H2
//                     numberOfLines={1}
//                     style={{ textAlign: 'center' }}
//                 >
//                     Vikas Kumar
//                 </text.H2>
//                 <text.T16
//                     numberOfLines={1}
//                     style={{ textAlign: 'center', marginBottom: 20 }}
//                 >
//                     kristinwatson@mail.com
//                 </text.T16> */}

//                 {
//                     isLogin && <items.ProfileItem
//                         title='Dashboard'
//                         icon={<svg.HomeTabSvg />}
//                         containerStyle={{ marginBottom: 6 }}
//                         onClick={() => {
//                             navigate('/dashboard');
//                         }}
//                     />
//                 }

//                 {isLogin && (
//                     <>
//                         <items.ProfileItem
//                             title='My Booking'
//                             icon={<svg.BookingSvg />}
//                             containerStyle={{ marginBottom: 6 }}
//                             onClick={() => {
//                                 navigate('/my-booking');
//                             }}
//                         />
//                         <items.ProfileItem
//                             title='Shortlisted Properties'
//                             icon={<svg.HeartSvg />}
//                             containerStyle={{ marginBottom: 6 }}
//                             onClick={() => {
//                                 navigate('/shortlisted');
//                             }}
//                         />
//                     </>
//                 )
//                 }
//                 {/* <items.ProfileItem
//                     title='Recent Visits"'
//                     icon={<svg.HeartSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                 /> */}
//                 <items.ProfileItem
//                     title='View Help Center'
//                     icon={<svg.HelpCirceSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/profile/help-and-support');
//                     }}
//                 />

//                 {/* <items.ProfileItem
//                     title='Pay Rent'
//                     icon={<svg.HeartSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/profile/payrent');
//                     }}
//                 /> */}
//                 {/* <items.ProfileItem
//                     title='My Coupons'
//                     icon={<svg.GiftSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/profile/my-coupons');
//                     }}
//                 /> */}
//                 {/* <items.ProfileItem
//                     title='Wallet'
//                     icon={<svg.WalletSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/profile/my-wallet');
//                     }}
//                 /> */}

//                 {/* <items.ProfileItem
//                     title='Help & Support'
//                     icon={<svg.HelpCirceSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/profile/help-and-support');
//                     }}
//                 /> */}
//                 <items.ProfileItem
//                     title='Privacy Policy'
//                     icon={<svg.FileTextSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/profile/privacy-policy');
//                     }}
//                 />

//                 <items.ProfileItem
//                     title='Terms & Conditions'
//                     icon={<svg.FileTextSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/terms-conditions');
//                     }}
//                 />

//                 <items.ProfileItem
//                     title='Our Services'
//                     icon={<svg.FileTextSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/our-services');
//                     }}
//                 />

//                 <items.ProfileItem
//                     title='Contact Us'
//                     icon={<svg.FileTextSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/contact-us');
//                     }}
//                 />

//                 {isLogin ? (
//                     // If both tokens are present => Show "Sign out"
//                     <items.ProfileItem
//                         navIcon={false}
//                         title='Sign out'
//                         icon={<svg.LogOutSvg />}
//                         containerStyle={{ marginBottom: 20 }}
//                         onClick={() => {
//                             localStorage.clear();
//                             localStorage.clear();
//                             navigate('/home');
//                         }}
//                     />
//                 ) : (
//                     // If tokens are missing => Show "Login"
//                     <items.ProfileItem
//                         navIcon={false}
//                         title='Login'
//                         icon={<svg.LogOutSvg />}
//                         containerStyle={{ marginBottom: 20 }}
//                         onClick={() => {
//                             localStorage.clear();
//                             localStorage.clear();
//                             navigate('/onbording1');
//                         }}
//                     />
//                 )}

//             </main>
//         );
//     };

//     return (
//         <>
//             {isOpen && (
//                 <div
//                     onClick={onClose}
//                     style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: leftPosition,
//                         // width: `100vw`, // Remaining screen
//                         width: viewport.width < 650 ? '100vw' : `calc(100vw - ${leftPosition}px)`,
//                         // Remaining screen
//                         height: '100vh',
//                         backgroundColor: 'rgba(0,0,0,0.5)',
//                         zIndex: 99998,
//                     }}
//                 />
//             )}
//             <div
//                 style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: isOpen ? leftPosition : '-300px',
//                     width: 300,
//                     height: '100vh',
//                     backgroundColor: '#fff',
//                     boxShadow: '2px 0 10px rgba(0,0,0,0.2)',
//                     transition: 'left 0.3s ease-in-out',
//                     zIndex: 99999,
//                     overflowY: 'auto',
//                 }}
//             >
//                 {/* {renderHeader()} */}
//                 {renderContent()}
//             </div>
//         </>
//     )
// };

// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { hooks } from '../hooks';

// import { text } from '../text';
// import { items } from '../items';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';

// type DrawerProps = {
//     isOpen: boolean;
//     onClose: () => void;
// };

// export const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
//     const location = useLocation();
//     const { pathname } = useLocation();
//     const [leftPosition, setLeftPosition] = React.useState(0);

//     const [viewport, setViewport] = useState({
//         width: window.innerWidth,
//         height: window.innerHeight,
//     });

//     useEffect(() => {
//         const handleResize = () => {
//             setViewport({
//                 width: window.innerWidth,
//                 height: window.innerHeight,
//             });
//         };
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     useEffect(() => {
//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     // console.log(viewport, '...............');

//     useEffect(() => {
//         if (viewport.width > 650) {
//             setLeftPosition((viewport.width - 650) / 2);
//         } else {
//             setLeftPosition(0);
//         }
//     }, [viewport.width]);

//     // console.log(leftPosition, '....................');

//     const navigate = hooks.useNavigate();

//     const renderImageBackground = (): JSX.Element => {
//         return <components.Background version={1} />;
//     };

//     const renderHeader = (): JSX.Element => {
//         return <components.Header title='My Profile' />;
//     };

//     const renderBottomTabBar = (): JSX.Element => {
//         return <components.BottomTabBar />;
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main className='container'>
//                 <div
//                     style={{
//                         width: '50%',
//                         margin: '0 auto',
//                         marginBottom: 20,
//                         marginTop: 10,
//                         position: 'relative',
//                         cursor: 'pointer',
//                         userSelect: 'none',
//                     }}
//                     onClick={() => navigate('/profile/edit')}
//                 >
//                     <img
//                         // src='https://george-fx.github.io/nuton_api/assets/users/01.jpg'
//                         src='https://media.istockphoto.com/id/1131164548/vector/avatar-5.jpg?s=612x612&w=0&k=20&c=CK49ShLJwDxE4kiroCR42kimTuuhvuo2FH5y_6aSgEo='
//                         alt='Profile'
//                         style={{ width: '100%', height: 'auto', borderRadius: '50%' }}
//                     />
//                     {/* <img
//                         src={require('../assets/other/02.png')}
//                         alt='camera'
//                         style={{
//                             position: 'relative',
//                             right: 0,
//                             bottom: 0,
//                             width: '30%',
//                             height: 'auto',
//                         }}
//                     /> */}
//                 </div>
//                 <text.H2
//                     numberOfLines={1}
//                     style={{ textAlign: 'center' }}
//                 >
//                     Vikas Kumar
//                 </text.H2>
//                 <text.T16
//                     numberOfLines={1}
//                     style={{ textAlign: 'center', marginBottom: 20 }}
//                 >
//                     kristinwatson@mail.com
//                 </text.T16>
//                 <items.ProfileItem
//                     title='Pay Rent'
//                     icon={<svg.HeartSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                 // onClick={() => {
//                 //     navigate('/profile/payrent');
//                 // }}
//                 />
//                 {/* <items.ProfileItem
//                     title='My Coupons'
//                     icon={<svg.GiftSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/profile/my-coupons');
//                     }}
//                 /> */}
//                 {/* <items.ProfileItem
//                     title='Wallet'
//                     icon={<svg.WalletSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/profile/my-wallet');
//                     }}
//                 /> */}
//                 <items.ProfileItem
//                     title='Help & Support'
//                     icon={<svg.HelpCirceSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                 // onClick={() => {
//                 //     navigate('/profile/help-and-support');
//                 // }}
//                 />
//                 <items.ProfileItem
//                     title='Privacy Policy'
//                     icon={<svg.FileTextSvg />}
//                     containerStyle={{ marginBottom: 6 }}
//                     onClick={() => {
//                         navigate('/profile/privacy-policy');
//                     }}
//                 />
//                 <items.ProfileItem
//                     navIcon={false}
//                     title='Sign out'
//                     icon={<svg.LogOutSvg />}
//                     containerStyle={{ marginBottom: 20 }}
//                     onClick={() => {
//                         navigate('/onbording3');
//                     }}
//                 />
//             </main>
//         );
//     };

//     return (
//         <>
//             {isOpen && (
//                 <div
//                     onClick={onClose}
//                     style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: leftPosition,
//                         // width: `100vw`, // Remaining screen
//                         width: viewport.width < 650 ? '100vw' : `calc(100vw - ${leftPosition}px)`,
//                         // Remaining screen
//                         height: '100vh',
//                         backgroundColor: 'rgba(0,0,0,0.5)',
//                         zIndex: 99998,
//                     }}
//                 />
//             )}
//             <div
//                 style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: isOpen ? leftPosition : '-300px',
//                     width: 300,
//                     height: '100vh',
//                     backgroundColor: '#fff',
//                     boxShadow: '2px 0 10px rgba(0,0,0,0.2)',
//                     transition: 'left 0.3s ease-in-out',
//                     zIndex: 99999,
//                     overflowY: 'auto',
//                 }}
//             >
//                 {/* {renderHeader()} */}
//                 {renderContent()}
//             </div>
//         </>
//     )
// };
